import {
  findOneBooking,
  createBooking,
  reserveBooking,
  startBooking,
  stopBooking,
  cancelBooking,
} from "./provider-booking.api"

import { findAllFacilities, findOneFacility } from "./facility.api"

import { getApiInformation } from "./info.api"
import { login } from "./auth.api"
import {
  findBookingsOfFacility,
  findOneFacility as adminFindOneFacility,
  findAllFacilities as adminFindAllFacilities,
} from "./admin.api"
import { findAllGatesForFacility, openGateByBooking } from "./iotControl.api"
import { getBookingPrice } from "@/app/api/booking.api"

export const api = {
  getApiInformation,
  createBooking,
  findOneBooking,
  reserveBooking,
  startBooking,
  stopBooking,
  cancelBooking,
  findAllFacilities,
  findOneFacility,

  // IoT control methods
  findAllGatesForFacility,
  openGateByBooking,
  getBookingPrice,
  admin: {
    login,
    // Bookings
    findBookingsOfFacility,

    // Facility
    findOneFacility: adminFindOneFacility,
    findAllFacilities: adminFindAllFacilities,
  },
}
